import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as MenuConsultasActions } from '../modulos/store/menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Titulo from './Titulo'
import Carregando from './Carregando'
import ItemMenu from './ItemMenu'
import SubMenu from './SubMenu'
import 'moment/locale/pt-br'

class MenuConsultas extends React.Component {
    componentDidMount() {
        if (!this.props.menu.carregando && this.props.menu.lista.length === 0) {
            this.props.buscaMenu()
        }
    }

    toggleSelecionaItemMenu(e) {
        const menu = document.querySelector('.menuFlutuante')
        const menuSlider = menu.querySelector('.menuContainerOpcoes')

        menuSlider.classList.toggle('subMenuAberto')
    }

    render() {
        if (!this.props.menu.carregando) {
            let retornaItens = this.props.menu.lista.filter(e => e.nivel >= 2)

            let menu = []
            let submenu = null
            let submenuItens = null
            let imagem = null
            retornaItens.forEach((e, i) => {
                if (i + 1 < retornaItens.length && e.nivel < retornaItens[i + 1].nivel) {
                    submenu = e.tituloMenu
                    submenuItens = []
                    imagem = e.imagem
                }

                // se não é menu.... é item!
                if (!e.menu) {
                    let params = {
                        conteudo: e.conteudo,
                        titulo: e.tituloMenu,
                        imagem: e.imagem,
                    }
                    let item = <ItemMenu key={i} index={i} item={e} params={params} toggleMenu={this.props.toggleMenuMobile} />
                    // appenda na lista adequada
                    if (submenuItens) {
                        submenuItens.push(item)
                    } else {
                        menu.push(item)
                    }
                }

                if (i + 1 < retornaItens.length && e.nivel > retornaItens[i + 1].nivel) {
                    menu.push(
                        <SubMenu
                            key={Math.random()}
                            titulo={submenu}
                            conteudo={submenuItens}
                            imagem={imagem}
                            toggleSelecionaItemMenu={this.toggleSelecionaItemMenu.bind(this)}
                        />
                    )
                    submenuItens = null
                }
            })

            return (
                <div id="menu">
                    <div className="menuMobileSombra" onClick={() => this.props.toggleMenuMobile()}></div>
                    <ul id="menuList">
                        <div className="menuMobileHeader">
                            <Titulo />
                            <FontAwesomeIcon onClick={() => this.props.toggleMenuMobile()} className="iconeMenu" icon={['fas', 'times']} title="Fechar Menu" />
                        </div>
                        <div className="menuContainerOpcoes">
                            {menu}
                            <div className="dataHoraContainer">
                                <p className="dataHoraTexto">{this.props.currentDateTime}</p>
                                <p>Horário padrão de Brasília</p>
                            </div>
                        </div>
                    </ul>
                </div>
            )
        } else return <Carregando />
    }
}

const mapStoreToProps = store => ({
    menu: store.sistema.menu,
})

const mapDispatchToProps = dispatch => bindActionCreators({ ...MenuConsultasActions }, dispatch)

export default connect(mapStoreToProps, mapDispatchToProps)(MenuConsultas)
